import { AntSelectValue } from 'controls/react/ant/ant-select/types';

export function reorder<VT extends AntSelectValue>(list: VT, startIndex: number, endIndex: number) {
	if (!Array.isArray(list)) return list;

	const result = [...list];

	const [removed] = result.splice(startIndex, 1);
	result.splice(endIndex, 0, removed);

	return result as VT;
}
